import { useState } from 'react';
import { useLayoutEffect_SAFE_FOR_SSR } from '@alfalab/hooks';
import { browser } from '../browser.js';

function useCustomWebkitScrollbar() {
    var _a = useState(false), shouldUseCustomScrollbar = _a[0], setShouldUseCustomScrollbar = _a[1];
    useLayoutEffect_SAFE_FOR_SSR(function () {
        if (browser.getScrollbarSize() > 0 && browser.isWebkitBased()) {
            setShouldUseCustomScrollbar(true);
        }
    }, []);
    return shouldUseCustomScrollbar;
}

export { useCustomWebkitScrollbar };
